"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.209 3C3.5413 3 3 3.5413 3 4.209v15.582C3 20.4587 3.5413 21 4.209 21h15.582c.6677 0 1.209-.5413 1.209-1.209V4.209C21 3.5413 20.4587 3 19.791 3H4.209zm4.3656 3.9963c0 .8717-.7066 1.5783-1.5783 1.5783S5.4179 7.868 5.4179 6.9963s.7067-1.5784 1.5784-1.5784 1.5783.7067 1.5783 1.5784zm4.1642 3.7611c.3022-.6044 1.315-1.3297 2.5522-1.276 1.5.065 2.0473.6696 2.3572 1.012l.0272.0299c.2945.3241.5037.9068.638 1.5448.0867.4118.0627 3.0216.0443 5.0201-.0044.4788-.0085.9226-.0107 1.2926h-2.6866v-5.0374c-.0223-.3582-.2237-1.2297-.9067-1.376-.8395-.1799-1.3097.0549-1.5783.3684-.403.4701-.4366 1.0746-.4366 1.4776v4.5672h-2.6866V9.7164h2.6866v1.041zm-7.0522 7.6232V9.7164H8.373v8.6642H5.6866z",
    fill: "#0069C6"
  })];
};

exports.default = _default;